import { ILandingPageComponentPermissionQuery } from '../interfaces/landing-page-component-permission.query.interface';

export class LandingPageComponentPermission {
    name: string;
    isGranted: boolean;

    constructor(query: ILandingPageComponentPermissionQuery) {
        this.name = query.name;
        this.isGranted = query.is_granted;
    }
}
